<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="toggleSidebar()"
                >
                    ×
                </button>
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="!data || !data['id']">Add News</h5>
                    <h5 class="modal-title" *ngIf="data && data['id']">Update News</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <form class="form mt-2 shadow-none" novalidate [formGroup]="addNewsForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Category</label>
                                        <select class="form-control" id="category_id" formControlName="category_id">
                                            <option value="">Select Category</option>
                                            <option [value]="newscateogry?.id"
                                                    *ngFor="let newscateogry of newsCategory">{{newscateogry.name}}</option>
                                        </select>
                                        <small *ngIf="submitted && addNewsForm.get('category_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Sub Category</label>

                                        <select class="form-control" id="subcategory_id" formControlName="subcategory_id">
                                            <option value="">Select Sub Category</option>
                                            <option [value]="newssubcateogry?.id"
                                                    *ngFor="let newssubcateogry of newsSubCategory">{{newssubcateogry.name}}</option>
                                        </select>
                                        <small *ngIf="submitted && addNewsForm.get('subcategory_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="heading">Heading</label>
                                        <input class="form-control" id="heading" type="text" formControlName="heading">
                                        <small *ngIf="submitted && addNewsForm.get('heading').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="heading">Url</label>
                                        <input class="form-control" id="url" type="text" formControlName="url">
                                        <small *ngIf="submitted && addNewsForm.get('url').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="meta_title">Meta Title</label>
                                        <textarea class="form-control resize-none" id="meta_title" type="text"
                                                  formControlName="meta_title"></textarea>
                                        <small *ngIf="submitted && addNewsForm.get('meta_title').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="meta_title">Meta Description</label>
                                        <textarea class="form-control resize-none" id="meta_description" type="text"
                                                  formControlName="meta_description"></textarea>
                                        <small *ngIf="submitted && addNewsForm.get('meta_description').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>



                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="meta_title">Canonical Tag</label>
                                        <textarea class="form-control resize-none" id="canonical_tag" type="text"
                                                  formControlName="canonical_tag"></textarea>
                                        <small *ngIf="submitted && addNewsForm.get('canonical_tag').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>




                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <button type="button" rippleEffect class="btn btn-danger" data-dismiss="modal"
                                            aria-label="Close" (click)="toggleSidebar()">
                                        Cancel
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="submit()" *ngIf="!data || !data['id']">Submit
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="update()" *ngIf="data && data['id']">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </form>
        </div>
    </div>
    <!-- Modal to add new user Ends-->
</div>

